import { Component, OnInit } from '@angular/core'
import { SharedServices } from '../../../services/shared.services'
import { AuthService } from '../../../services/auth.services'
import { ActivatedRoute, Router } from '@angular/router'
import { ModalService } from '../../../services/modal.service'
import { RestServices } from '../../../services/rest.services'
import 'rxjs/add/operator/filter'
import { notification } from 'onsenui'
import { MatrixServices } from '../../../services/image/matrix.services'
import { imageUrl } from '../../../../helper/common'

@Component({
    selector: 'app-layout-app-element-detail',
    templateUrl: './layout-app-element-detail.component.html',
    styleUrls: [
        '../../../stagingcss/root-ui-view.component.css',
        '../../../stagingcss/main-body.component.css',
        '../../../stagingcss/main-view.component.css',
        '../../../stagingcss/lui-select.component.css',
        './layout-app-element-detail.component.css',
    ],
})
export class LayoutAppElementDetailComponent implements OnInit {
    en = {}
    showEN = true
    arrayMenu = []
    url
    arrList
    idRoom
    srcImage
    titleRoom
    statusTab
    statusAlerRouting
    matrixAvatar
    titleRoomFull

    constructor(private auth: AuthService, private router: Router, private activatedRoute: ActivatedRoute, private restApi: RestServices, private _sharedService: SharedServices, private modalservice: ModalService, public matrixServices: MatrixServices) {
        this.arrayMenu = this._sharedService.returnArrayMenu()
        const communicationroomPath = this.router.url.includes('room')
        if (communicationroomPath === true) {
            this.arrayMenu = this._sharedService.returnArraymenuleft('communication_room')
        }
        this.idRoom = activatedRoute.snapshot.children[0]['params'].id
        this._sharedService.changeEmitted$.subscribe(
            success => {
                if (success) {
                    this.modalservice.emitChange(success)
                }
                if (success === 'alertCheckRouting') {
                    this.statusAlerRouting = true
                }
                if (success === 'removestatusRouting') {
                    this.statusAlerRouting = false
                }
                if (success && success[0] === 'loadTitleSave') {
                    this.listCommunicationId(this.idRoom)
                }
            })

        this.en = this.auth.showLang(this.showEN)
        this.listCommunicationId(this.idRoom)
    }

    ngOnInit() {
    }

    changeLanguage() {
        return this.en = this.auth.showLang(this.showEN)
    }

    peddingHome() {
        if (this.statusAlerRouting === true) {
            notification.confirm({
                message: this.en['alert-content'],
                title: '<b>' + this.en['alert-title'] + '</b>',
                cancelable: true,
                buttonLabels: [this.en['alert-cancel'], this.en['alert-discard'], this.en['alert-save']],
                modifier: 'rowfooter',
                callback: i => {
                    if (i === 1) {  // here this is not cancelled.  1 is correct.
                        this.router.navigateByUrl('app/top')
                        this.statusAlerRouting = false
                    }
                    if (i === 2) {  // here this is not cancelled.  1 is correct.
                        this._sharedService.emitChange('saveRoom')
                        this.router.navigateByUrl('app/top')
                        this.statusAlerRouting = false
                    }
                },
            })
        } else {
            this.router.navigateByUrl('app/top')
        }
    }

    onAction($event) {
        setTimeout(() => {
            $event.done()
            // this.items.push(0);
        }, 200)
    }

    listCommunicationId(idRoom) {
        const resourceUrl = 'resource'
        const map = {}
        map[idRoom] = true
        const resourceData = {
            actions: [],
            status: {
                clinic: {
                    paths: {
                        '{}': true,
                    },
                },
                setting: {
                    map: {
                        common: true,
                    },
                    paths: {
                        '{}': true,
                    },
                },
                staff: {
                    paths: {
                        '{"roles":"cordinator"}': true,
                        '{"roles":"doctor"}': true,
                        '{}': true,
                    },
                },
                room: {
                    map,
                },
            },
        }
        this.auth.authToken().then(tokenReNew => {
            this.restApi.http_post(resourceUrl, resourceData, tokenReNew).subscribe(
                success => {
              
                    if(!success['response']['room']) {                                             
                       this.router.navigate(['./app/main/communication/not-found'])
                        return
                    }
                    this.arrList = success['response']['room']['map'][idRoom]
                    if (this.arrList && this.arrList['faceImage']) {
                        this.srcImage = imageUrl + this.arrList['faceImage']['id'] + '?type=medium'
                        this.matrixAvatar = this.arrList['faceImage']['matrix']
                    } else {
                        this.srcImage = ''
                        this.matrixAvatar = [1, 0, 0, 1]                   

                    }
                    this.titleRoom = this.arrList['title']
                    if (typeof this.titleRoom !== 'undefined' && this.titleRoom.length > 10) {
                        this.titleRoomFull = this.arrList['title']
                        this.titleRoom = this.titleRoom.substring(0, 10) + '...'
                    }
                },
            )
        })
    }

    // check tab
    checkTab(id) {
        this.statusTab = id
        const statusTabRoom = ['statusTab', id]
        if (this.statusAlerRouting === true) {
            notification.confirm({
                message: this.en['alert-content'],
                title: '<b>' + this.en['alert-title'] + '</b>',
                cancelable: true,
                buttonLabels: [this.en['alert-cancel'], this.en['alert-discard'], this.en['alert-save']],
                modifier: 'rowfooter',
                callback: i => {
                    if (i === 1) {  // here this is not cancelled.  1 is correct.
                        this._sharedService.emitChange(statusTabRoom)
                        this.statusAlerRouting = false
                    }
                    if (i === 2) {  // here this is not cancelled.  1 is correct.
                        this._sharedService.emitChange(statusTabRoom)
                        this._sharedService.emitChange('saveRoom')
                        this.statusAlerRouting = false
                    }
                },
            })
        } else {
            this._sharedService.emitChange(statusTabRoom)
        }
    }

    backRoomDetail() {
        if (this.statusAlerRouting === true) {
            notification.confirm({
                message: this.en['alert-content'],
                title: '<b>' + this.en['alert-title'] + '</b>',
                cancelable: true,
                buttonLabels: [this.en['alert-cancel'], this.en['alert-discard'], this.en['alert-save']],
                modifier: 'rowfooter',
                callback: i => {
                    if (i === 1) {  // here this is not cancelled.  1 is correct.
                        this.router.navigateByUrl('app/main/communication/top')
                        this.statusAlerRouting = false
                    }
                    if (i === 2) {  // here this is not cancelled.  1 is correct.
                        this._sharedService.emitChange('saveRoom')
                        this.router.navigateByUrl('app/main/communication/top')
                        this.statusAlerRouting = false
                    }
                },
            })
        } else {
            this.router.navigateByUrl('app/main/communication/top')
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/app_manager/app_element/layout-app-element-detail/layout-app-element-detail.component.ts